/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {

        // $('iframe[id*=ticketing]').on('click', function() {
        //   console.warn($(this).offset().top);
        //   $('body,html').animate({
        //       scrollTop: $(this).offset().top - 130,
        //     }, 300);
        // });

        $(document).on('click','.cgf-hashed-link', function(e){
          e.preventDefault();
          var href = $(this).attr('data-href');
          if ( href ) {
            href = href.replace('[cgdc]', '.com');
            href = href.replace('[cgd]', '.');
            href = href.replace('[cga]', '@');
            location.href = "mailto:" + href;
          }
        });
        $(document).on('click','.cgf-cb-link', function(e){
          e.preventDefault();
          var href = $(this).attr('href');
          if ( href ) {
            href = href.replace('mailto:', '');
            href = href.replace('[cgdc]', '.com');
            href = href.replace('[cgd]', '.');
            href = href.replace('[cga]', '@');
            location.href = "mailto:" + href;
          }
        });

        $(document).on('click','a[href*="[cga]"]', function(e){
          e.preventDefault();
          var href = $(this).attr('href');
          if ( href ) {
            href = href.replace('mailto:', '');
            href = href.replace('[cgdc]', '.com');
            href = href.replace('[cgd]', '.');
            href = href.replace('[cga]', '@');
            location.href = "mailto:" + href;
          }
        });

        $(document).find('.cgf-timeline-slider').each(function () {
          $(this).find('.horizontal-timeline').horizontalTimeline({
            dateDisplay: "date",
            autoplay: true,
            autoplaySpeed: 8,  // Sec
            autoplayPause_onHover: true,
            useTouchSwipe: true,
            date: 'DD MM YYYY',
            iconClass: {
              "base": "", // Space separated class names
              "scrollLeft": "cgf-hidden",
              "scrollRight": "cgf-hidden",
              "prev": "cgf-timeline-chevron-left",
              "next": "cgf-timeline-chevron-right",
              "pause": "cgf-hidden",
              "play": "cgf-hidden"
            },

          });
        });

        $(window).load(function(){
          var iframe_changed = false;
          var animating = false;
          window.addEventListener('message', receiver, false);
          function receiver(e) {
            if (e.origin == '*') {
              return;
            } else {
              var message = e.data;
              if ( e.origin == 'https://site.evenium.net' && ( message.indexOf('scrollToOffset') !== -1 || message.indexOf('mutationObserver') !== -1 ) ) {
                if ( $('iframe[id*=ticketing]').offset().top < jQuery(window).scrollTop() + 150  ) {
                  if ( ! animating ) {
                    animating = true;
                    $('body,html').animate({
                      scrollTop: $('iframe[id*=ticketing]').offset().top - 250,
                    }, 300);
                    setTimeout(function(){
                      animating = false;
                    }, 300)
                  }
                }
              }
            }
          }
        });

        var query_s_params  = new URLSearchParams(window.location.search);
        var query_params    = Object.fromEntries(query_s_params.entries());
        if( typeof query_params.topic !== 'undefined' ) {
          if ( $('#mc_embed_signup').length > 0 ) {
            var topics = decodeEntities ( query_params.topic ).split(",");
            for (var i = topics.length - 1; i >= 0; i--) {
              $(document).find('.mc-field-group.input-group').each(function(){
                $(this).find('li > label').each(function(){
                  console.warn(topics[i].toLowerCase());
                  console.warn($(this).text().replace(/\s+/g, " ").toLowerCase());
                  if ( $(this).text().toLowerCase().includes( topics[i].toLowerCase() ) ) {
                    $(this).trigger('click');
                  }
                });
              });
            }
          }
        }

        var scriptadded = false;

        function isScrolledIntoView(elem) {
          var docViewTop = $(window).scrollTop();
          var docViewBottom = docViewTop + $(window).height();

          var elemTop = $(elem).offset().top;
          var elemBottom = elemTop + $(elem).height();

          return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        }

        function loadExecuteTwitter() {
          var twttrWidget = $(document).find('[data-twitter]');
          if (twttrWidget.length > 0 && !scriptadded) {
            if (isScrolledIntoView(twttrWidget)) {
              var elem = document.createElement('script');
              var insertElem = document.getElementsByTagName('script')[0];

              elem.src = ' https://platform.twitter.com/widgets.js';

              scriptadded = true;
              $('.tweet-feed-cont').append(elem);

            }
          }
        }

        $(window).scroll(function () {
          loadExecuteTwitter();
        });

        loadExecuteTwitter();

        $(document).find('.cgf-single-post-layout .post-main-content-area img').each(function() {
          var image = $(this);
          if ( image.closest('table').length <= 0 ) {
            if ( image.hasClass('alignright') || image.hasClass('alignleft') || image.hasClass('img_left') || image.hasClass('img_right') ) {
              // if ( image.hasClass('alignright') || image.hasClass('img_right') ) {
              //   image.addClass('cgf-content-image-sm').addClass('ci-right');
              // }
              // if ( image.hasClass('alignleft') || image.hasClass('img_left') ) {
              //   image.addClass('cgf-content-image-sm').addClass('ci-left');
              // }
            } else {
              if ( image.width() < $(this).closest('.post-main-content-area').find('> .content-sizer').innerWidth() ) {
                image.wrap('<span class="cgf-content-image-off ci-padded"></span>');
              } else {
                image.wrap('<span class="cgf-content-image-off ci-full-width"></span>');
              }
            }
          }
        });

        $('.cgf-single-post-layout .post-main-content-area iframe[src*="youtube"]').wrap("<div class='gfsi-vid-cont'></div>");
        $('.cgf-single-post-layout .post-main-content-area iframe[src*="vimeo"]').wrap("<div class='gfsi-vid-cont'></div>");


        $('.cgf-single-post-layout .sidebar').stick_in_parent({ offset_top: 140 });

        // JavaScript to be fired on all pages
        var y = $(window).scrollTop();
        $(window).load(function () {

          $(window).scrollTop(y + 150);
          $(window).scrollTop(y - 150);

          setTimeout(function () {
            $(".loading-screen").fadeOut("slow");
          });
          setTimeout(function () {
            $('.home .banner--slider-info h1').css('opacity', '1');
          }, 500);
          setTimeout(function () {
            $(".banner--slider-container .banner--slider-info h1").addClass('info-transform');
          }, 600);
          setTimeout(function () {
            $(".banner--slider-container .banner--slider-info .caption, .banner-btn").addClass('info-transform');
          }, 1300);
          setTimeout(function () {
            $(".header-wrap, .members-fade-block").addClass('banner-transform');
          }, 1800);

          var b = 0;
          $(window).scroll(function () {
            if ($('.trigger').length > 0) {
              var oToptrig = $('.trigger').offset().top - window.innerHeight;
              if (b === 0 && $(window).scrollTop() > oToptrig) {
                $(".trigger").addClass("drawn");
              }
            }
          });

        });


        $('.cgf-partner-logos-wrap .owl-carousel').each(function () {
          $(this).owlCarousel({
            center: false,
            items: 2,
            loop: true,
            nav: false,
            dots: false,
            margin: 20,
            drag: true,
            autoplay: true,
            smartSpeed: 1500,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            responsive: {
              767: {
                items: 3,
              },
              992: {
                items: 5,
              },
            },
          });
        });

        var home_slc =  $('.cgf-homepage-slider .cgf-homepage-slider-wrap .slick-carousel');
        home_slc.on('init', function(event, slick){
          var active = $('.cgf-homepage-slider .cgf-homepage-slider-wrap').find('li.active');
          if ( active.length > 0 && active.attr('data-lazy') ) {
            active.attr('style', active.attr('data-lazy')).removeAttr('data-lazy').addClass('cgf-lazyLoad');
          }
        });

        home_slc.slick({
          dots: false,
          arrows: false,
          fade: true,
          autoplay: true,
          autoplaySpeed: 4500,
        });

        home_slc.on('afterChange', function (event, slick, currentSlide, nextSlide) {
          // console.log(currentSlide);
          var image_container = $(slick.$slider).closest('.cgf-homepage-slider').find('.slider-image-container');
          if (image_container.length > 0 && image_container.find('li[data-index="' + currentSlide + '"]').length > 0) {
            image_container.find('li').removeClass('active');
            image_container.find('li[data-index="' + currentSlide + '"]').addClass('active');
            var crs = image_container.find('li[data-index="' + currentSlide + '"]');
            crs.attr('style', crs.attr('data-lazy')).removeAttr('data-lazy').addClass('cgf-lazyLoad');
          }
        });

        $(' .owl-carousel').each(function () {
          $(this).owlCarousel({
            center: true,
            items: 1,
            loop: true,
            nav: false,
            dots: false,
            margin: 20,
            drag: true,
            autoplay: true,
            lazyLoad: true,
            autoplayTimeout: 6000,
            autoplayHoverPause: true
          });
        });


        $('.testimonial-slider-flex .testimonial-slider').owlCarousel({
          center: false,
          items: 1,
          loop: true,
          nav: false,
          dots: true,
          margin: 40,
          drag: true,
          autoplay: true,
          autoplayTimeout: 10000,
          autoplayHoverPause: true
        });

        $(document).on('click', '.sfw-filter-toggle', function (e) {
          e.preventDefault();
          $(this).toggleClass('active');
          $(this).closest('.search-filter-wrap').find('.sfw-filter-row').toggleClass('open');
        });

        $(window).scroll(function () {
          if ($(window).scrollTop() >= 150) {
            $('.cgf-new-site-header').addClass('slideDown');
            $('.select-lang').removeClass('init-visible');
            $('.members-area-menu__dropdown').removeClass('open-dropdown-members');
          } else {
            $('.cgf-new-site-header').removeClass('slideDown');
            $('.sub-menu').removeClass('menu-show');
            $('.wrap-page').removeClass('fixed');
            $('.top-link').removeClass('active-link');
            $('.sub-menu-wrap').removeClass('menu-show');
          }


        });


        var grid = $(document).find('.cgf-masonry-wrap');

        function masonry_facet() {
          if (grid.length > 0) {
            grid.masonry({
              // options
              columnWidth: '.resource-sizer',
              itemSelector: '.resource-card',
              percentPosition: true,
            });
            setTimeout(function () {
              grid.masonry('reloadItems');
              grid.masonry('layout');
              $(window).resize();
            }, 200);

            $('.resource-card img').on('load', function (event) {
              grid.masonry('reloadItems');
              grid.masonry('layout');
              $(window).resize();
            });
          }
          var last_item = grid.find('.resource-card').last();
          $('.res_sort_rel_f').attr('href', last_item.attr('data-sort_rel'));
          $('.res_sort_date_f').attr('href', last_item.attr('data-sort_date'));
        }

        masonry_facet();

        $(document).on('facetwp-loaded', function () {

          masonry_facet();
          $('.resources-svg-loader').hide();
          $('.resource-masonry-grid').removeClass('loading');

          var is_empty = true;
          var obj = FWP.facets;

          if (FWP.facets.keyword.length > 0) {
            $('.res-sort-filters').show();
          } else {
            $('.res-sort-filters').hide();
          }

          for (var prop in obj) {
            if (obj[prop].length > 0) {
              is_empty = false;
            }
          }

          if (is_empty) {
            // No filters selected
            $('.gradient-resource-wrap .resources-latest').slideDown('300');
          } else {
            // Filters selected
            $('.gradient-resource-wrap .resources-latest').slideUp('300');
          }

        });

        // Facet WP - Load More
        $(document).on('facetwp-refresh', function () {
          if (FWP.loaded) {
            $('.resource-masonry-grid').addClass('loading');
            $('.resources-svg-loader').show();
          }
        });


        /* **************** STICKY NAV ****************** */
        function viewport() {
          var e = window, a = 'inner';
          if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
          }
          return {width: e[a + 'Width'], height: e[a + 'Height']};
        }

        var screenDim = viewport();

        if ($('.sticky-menu-wrap').length > 0) {
          if (screenDim.width > 1024) {
            var stickyFromTop = $('.sticky-menu-wrap').offset().top - 100;
            $(window).on('scroll', function () {
              if ($(document).scrollTop() >= stickyFromTop) {
                $('.sticky-menu-wrap').addClass('affix');
              } else {
                $('.sticky-menu-wrap').removeClass('affix');
              }
            });
          }
        }

        // if ($('.cgf-init-menu-sticky').length > 0) {
        //   $('.cgf-init-menu-sticky .sticky-menu-wrap').affix({
        //     offset: {
        //       top: $('.cgf-init-menu-sticky').offset().top - 100
        //     }
        //   });
        // }


        $(document).find('.cgf-timeline-slider').each(function () {
          $(this).find('.horizontal-timeline').horizontalTimeline({
            dateDisplay: "date",
            autoplay: true,
            autoplaySpeed: 8,  // Sec
            autoplayPause_onHover: true,
            useTouchSwipe: true,
            date: 'DD MM YYYY',
            iconClass: {
              "base": "", // Space separated class names
              "scrollLeft": "cgf-hidden",
              "scrollRight": "cgf-hidden",
              "prev": "cgf-timeline-chevron-left",
              "next": "cgf-timeline-chevron-right",
              "pause": "cgf-hidden",
              "play": "cgf-hidden"
            },

          });
        });

        $('.has-children').on('click', function () {
          var elem = $(this);
          $(document).find('.img_placeholder, .img-contain').each(function () {
            var bg_img = $(this).attr('data-bgimg');
            if (bg_img) {
              $(this).css('background-image', 'url(' + bg_img + ')').removeAttr('data-bgimg');
            }
          });
        });

        $(document).on('click', '.cgf-mega-menu-wrap .menu-item-has-child > a', function (e) {
          e.preventDefault();
          var parent = $(this).closest('.menu-item-has-child');
          if (parent.hasClass('menu-item-open')) {
            parent.removeClass('menu-item-open');
            parent.closest('.cgf-mega-menu-wrap').removeClass('mm-menu-open');
            $('body').focus();
          } else {
            $(document).find('.cgf-mega-menu-wrap .menu-item-has-child').removeClass('menu-item-open');
            parent.addClass('menu-item-open');
            parent.closest('.cgf-mega-menu-wrap').addClass('mm-menu-open');
          }
        });

        $(document).on('click', '.menu-layout-two-cols .menu-item-has-submenu.submenu-links > a', function (e) {
          if (!$(this).closest('li').hasClass('sub-menu-open')) {
            e.preventDefault();
          }
          $(this).closest('li').toggleClass('sub-menu-open');
        });

        $(document).on('click', '.mega-menu-container-mobile .menu-layout-equal-cols .menu-item-has-submenu > a', function (e) {
          if (!$(this).closest('li').hasClass('sub-menu-open')) {
            e.preventDefault();
          }
          $(this).closest('li').toggleClass('sub-menu-open');
        });

        $(document).on('click', '.cgf-mega-menu-wrap .mm-menu-overlay', function () {
          $(document).find('.cgf-mega-menu-wrap .menu-item-has-child').removeClass('menu-item-open');
          $('.cgf-mega-menu-wrap').removeClass('mm-menu-open');
          $('body').focus();
        });

        $(document).scroll(function () {
          $(document).find('.cgf-mega-menu-wrap .menu-item-has-child').removeClass('menu-item-open');
          $('.cgf-mega-menu-wrap').removeClass('mm-menu-open');
          $('body').focus();
        });

        var a = 0;
        $(window).scroll(function () {
          if ($('.counter').length > 0) {
            var oTop = $('.counter').offset().top - window.innerHeight;
            if (a === 0 && $(window).scrollTop() > oTop) {
              $('.number-count').each(function () {
                var $this = $(this), countTo = $this.attr('data-count');
                $({
                  countNum: $this.text()
                }).animate({
                  countNum: countTo
                }, {
                  duration: 4000,
                  easing: 'swing',
                  step: function () {
                    $this.text(Math.floor(this.countNum));
                  },
                  complete: function () {
                    $this.text(this.countNum);
                    //alert('finished');
                  }
                });
              });
              a = 1;
            }
          }
        });

        $('#filter').submit(function (e) {
          e.preventDefault();

          var form = $('#filter');

          var url = form.attr('data-url');
          var page = form.attr('data-page');

          var filter = {};

          form.find('.filter-field').each(function () {
            var val = $(this).val();
            var name = $(this).attr('name');
            if (val.length > 0 && val !== 'any') {
              if (name !== 'language') {
                filter[name] = val;
              }

            }
          });

          var filter_string = $.param(filter);

          if (filter_string.length > 1) {
            url = url + '?' + filter_string;
          }

          window.location.replace(url);

          return false;
        });

        $('.has-children').on('click', function () {
          var elem = $(this);
          $(document).find('.img_placeholder, .img-contain').each(function () {
            var bg_img = $(this).attr('data-bgimg');
            if (bg_img) {
              $(this).css('background-image', 'url(' + bg_img + ')').removeAttr('data-bgimg');
            }
          });
        });


        $('.featured-news .post-block .featured-news-info').matchHeight({byRow: true});


        $('.lang-select').click(function () {
          var theLang = jQuery(this).attr('data-lang');
          jQuery('.goog-te-combo').val(theLang);
          //alert(jQuery(this).attr('href'));
          window.location = jQuery(this).attr('href');
          location.reload();
        });

        function googleTranslateElementInit() {
          new google.translate.TranslateElement({
            pageLanguage: 'en',
            layout: google.translate.TranslateElement.FloatPosition.TOP_LEFT
          }, 'google_translate_element');
        }

        function triggerHtmlEvent(element, eventName) {
          var event;
          if (document.createEvent) {
            event = document.createEvent('HTMLEvents');
            event.initEvent(eventName, true, true);
            element.dispatchEvent(event);
          } else {
            event = document.createEventObject();
            event.eventType = eventName;
            element.fireEvent('on' + event.eventType, event);
          }
        }

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
